import { Component, Input } from '@angular/core';
import { GymUtils } from '../../../util/gym-util';

@Component({
  selector: 'gymfinder-changelog-external-booking-info',
  templateUrl: './changelog-external-booking-info.component.html',
  styleUrls: ['./changelog-external-booking-info.scss'],
  standalone: false,
})
export class ChangelogExternalBookingInfoComponent {
  @Input()
  externalBookingInfo: any;

  getBookingType() {
    return (
      GymUtils.requirementTypes.find(
        type => type.value === this.externalBookingInfo.requirementType
      )?.label ?? '-'
    );
  }
}
